import { useState, useEffect, useRef, useCallback } from 'react';

export const usePresence = (token) => {
  const [connectedUsers, setConnectedUsers] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const wsRef = useRef(null);
  const reconnectRef = useRef(null);

  const connect = useCallback(() => {
    if (!token) return;
    
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const wsUrl = `${protocol}//${window.location.host}/api/ws/presence?token=${token}`;
    
    try {
      const ws = new WebSocket(wsUrl);
      wsRef.current = ws;

      ws.onopen = () => {
        if (reconnectRef.current) {
          clearTimeout(reconnectRef.current);
          reconnectRef.current = null;
        }
      };

      ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (data.type === 'presence') {
            setConnectedUsers(data.users || []);
          } else if (data.type === 'notification') {
            // Add notification with timestamp
            setNotifications(prev => [
              ...prev,
              { by: data.by, action: data.action, time: new Date() }
            ]);
          }
        } catch (e) {}
      };

      ws.onclose = () => {
        reconnectRef.current = setTimeout(() => connect(), 5000);
      };

      ws.onerror = () => {
        ws.close();
      };
    } catch (e) {}
  }, [token]);

  useEffect(() => {
    connect();
    return () => {
      if (wsRef.current) wsRef.current.close();
      if (reconnectRef.current) clearTimeout(reconnectRef.current);
    };
  }, [connect]);

  const clearNotifications = useCallback(() => {
    setNotifications([]);
  }, []);

  return { connectedUsers, notifications, clearNotifications };
};
